<template>
  <div>
    <div class="mb-5">
      <div class="location-home pt-2.5">
        <!-- <h3 class="fsize20 font-semibold">Home / {{ get_location }}</h3> -->
        <h3 class="fsize30 text-primary font-semibold mb-4" v-if="!cardView">
          {{ this.serviceName }}
        </h3>
        <h3 class="fsize30 font-semibold text-primary mb-4" v-if="cardView">
          Service Provider
        </h3>
      </div>

      <div class="flex ml-auto lg:mt-0 md:mt-0 mt-4">
        <!-- <b-form-input
          id="input-default"
          label-size="large"
          class=""
        ></b-form-input> -->

        <div class="search">
          <base-button
            @click="handleRoute('request-form', 'request-for-service')"
            type="primary"
            class="search-clr-btn ml-2"
            ><span> Request for Service </span>
            <!-- <span v-if="cardView"> About Service </span> -->
          </base-button>
          <base-button
            @click="handleService"
            type="primary"
            class="search-clr-btn ml-2"
          >
            <span> Know Your Service Provider </span>
          </base-button>
        </div>
      </div>
    </div>
    <div class="" v-show="!cardView">
      <!-- <img
        src="../../../assets/images/nodata.svg"
        alt="image"
        class="sprovider-img mx-auto"
      /> -->

      <p>
        <span class="font-bold text-primary"> Service Description:</span>
        Caregiving is a deeply rewarding experience, but it also comes with its
        share of physical and emotional challenges. Caregivers face daily
        struggles that can be difficult to manage alone. Without proper support,
        the demands of caregiving can take a toll on your mental and physical
        well-being.
      </p>
      <br />

      <div class="text-777777 font-normal mb-2">
        <span class="font-bold text-primary">
          Why Consider Caregiver Therapy and Counselling:
        </span>
        Engaging in therapy and counselling tailored for caregivers offers
        significant advantages:
      </div>
      <ul class="list-decimal font-bold mb-4">
        <li class="text-777777 font-normal">
          <span class="font-bold text-primary"> Emotional Support: </span>
          Professional therapists provide a safe space for you to express your
          emotions, offering guidance and understanding.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary"> Setting Boundaries: </span>
          Learn to set healthy boundaries, ensuring a balanced approach to
          caregiving while safeguarding your own needs.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary">
            Enhanced Problem-Solving:
          </span>
          Acquire effective problem-solving skills to navigate the challenges of
          caregiving more efficiently.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary">Improved Communication: </span>
          Strengthen communication with your care recipient and family members,
          fostering a more supportive caregiving environment.
        </li>
      </ul>

      <p>
        <span class="font-bold text-primary"> Our Service:</span>
        Caregiver Saathi is here to support you on your caregiving journey. We
        connect you with skilled therapists who specialize in caregiver therapy
        and counseling. These experts provide invaluable emotional support,
        helping you alleviate the emotional burden, anxiety, and loneliness that
        can accompany caring for a loved one.
        <br />
      </p>
      <p class="mt-4">
        <span class="font-bold mt-2 text-primary">For Whom:</span>
        Caregivers facing emotional challenges.
      </p>
      <h6 class="mt-3 fsize16 font-bold text-primary">Why Choose Us:</h6>
      <ul class="list-decimal font-bold mb-4">
        <li class="text-777777 font-normal">
          Access to compassionate therapists
        </li>

        <li class="text-777777 font-normal">
          Safe and non-judgmental environment
        </li>

        <li class="text-777777 font-normal">Learn coping strategies..</li>

        <li class="text-777777 font-normal">
          Strengthen your emotional well-being.
        </li>
      </ul>

      <p class="mb-2 underline">Prioritize Your Mental Health Today!</p>

      <p class="mb-2 text-gray">
        Price: Affordable sessions starting at
        <span class="text-dark font-semibold"
          >INR 2500/ session + 18% GST
        </span>
      </p>
      <p class="text-gray">
        For 5 or more sessions:
        <span class="text-dark font-semibold">Rs 2000/ session + 18% GST</span>
      </p>
    </div>
    <Bcard class="lg:mt-20 md:mt-20 mt-12" v-show="cardView" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Bcard from "./Bcard.vue";

export default {
  props: ["location"],
  components: {
    Bcard,
  },
  data() {
    return {
      dataFound: false,
      serviceName: "",
      cardView: false,
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_location: "get_location",
    }),
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
    }),
    ...mapState("auth", ["user"]),
  },
  methods: {
    handleRoute(name, params) {
      // if (Object.keys(this.user).length === 0) {
      //   this.$router.push({ name: "signin" });
      //   this.$swal.fire({
      //     title: "",
      //     text: "Please login to access this content",
      //     icon: "warning",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      //   return;
      // }
      this.$router.push({ name: name, params: { pathName: params } });
    },
    async handleService() {
      // this.$router.push({
      //   name: "map-inside",
      //   params: { service: this.serviceName },
      // });
      if (Object.keys(this.user).length === 0) {
        this.$router.push({ name: "signin" });
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.userDetails = sessionStorage.getItem("token");
      try {
        // if (this.userDetails === null) {
        //   this.$swal
        //     .fire({
        //       title: "Login!",
        //       text: "Please login to continue",
        //       icon: "info",
        //       confirmButtonText: "Okay",
        //       confirmButtonColor: "#830c81",
        //       showCancelButton: false,
        //     })
        //     .then((result) => {
        //       return this.$router.push({ name: "signin" });
        //     });
        //   return;
        // }
        this.cardView = !this.cardView;
        let payload = {
          service: this.serviceName,
        };
        let data = await this.$store.dispatch(
          "respitecare/getVolunteerByService",
          payload
        );
      } catch (error) {
        console.log(error);
      }

      // this.$router.push({ name: "product-services", query: { scroll: true } });
      // let urlToRedirect = `${window.location.origin}/product-services`;
      // localStorage.setItem("bookService", true);
      // window.open(urlToRedirect, "_blank");
    },
  },
  mounted() {
    if (this.get_volunteer_by_location.length > 0) {
      this.dataFound = true;
    }
    this.serviceName = this.$route.query.service;
    // console.log(this.serviceName);
  },
};
</script>

<style>
.search-clr-btn {
  color: #f8f9fe;
  background-color: #4f0a4b;
}
.fsize30 {
  font-size: 30px;
}
</style>
